import React, { Component } from 'react';
import { object, bool, func } from 'prop-types';

// Redux
import { connect } from 'react-redux';
import { hideBackButton, setHeaderTitle, showBackButton } from '../../../../actions/header/headerActions';
import { setMetadata } from '../../../../actions/metadata/metadataActions';

// Main Layout Components
import Layout from '../../../Layout';
import ActionsPanel from '../../../ActionsPanel';
import ContentPanel from '../../../ContentPanel';
import FamilyAccessContainer from '../FamilyAccess';
import Profile from '../Profile/Profile';
import AuditLog from '../AuditLog';
import SecondaryMenuItem from '../../../SecondaryMenu/SecondaryMenuItem';
import SecondaryMenu from '../../../SecondaryMenu/SecondaryMenu';

import FixedSecondaryHeaderBar from "../../../FixedSecondaryHeaderBar/FixedSecondaryHeaderBar"
import BaseBackButton from "./../../../BaseBackButton/BaseBackButton";

// Page styles
import cx from 'classnames';
import s from './LandingPage.css';

export class LandingPage extends Component {
  static propTypes = {
    isCollapsed: bool,
    showHeaderBackButton: func,
    hideHeaderBackButton: func,
    setHeaderTitle: func,
    setMetadata: func,
    user: object,
  };

  static defaultProps = {
      isCollapsed: true,
      secondaryMenuItems: []
  };

  constructor(props) {
    super(props);

    this.state = {
      userDetails: null,
      activeSecondaryMenuItem: null,
      viewAuditLog: false,
      windowWidth: null,
      expanded: null,
      secondaryMenuItems: []
    };

    this.isUnmounted = false;
  }

  // When the component mounts, set these variables
  componentWillMount() {

    this.setState({
      expanded: !this.props.isCollapsed,
      windowWidth: window.innerWidth,
    });

    this.props.setMetadata({
      activeMenuItemKey: 'account',
      pageTitle: 'Account',
      pageDescription: 'Manage account settings.',
    });

    this.props.setHeaderTitle('Account');
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.header.backButton && this.state.expanded) {
      this.goBack();
    }
    this.setupMenuItems(nextProps.user.isFamilyAccess);
  }

  // Listen to window and resize event
  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  // On unmount, remove listeners to prevent memory leaks
  componentWillUnmount() {
    this.isUnmounted = true;
    window.removeEventListener('resize', this.handleResize);
  }

  setupMenuItems = (isFamilyAccess) => {
      let secondaryMenuItems = [];
      let defaultSecondaryMenuItem = null;
      //We don't want to load anything if we haven't gotten the prop yet
      if(isFamilyAccess !== null) {
          if(!isFamilyAccess){
              secondaryMenuItems = [
                  {
                      key: 'profile',
                      name: 'My Profile',
                      path: '/account',
                  },
                  {
                      key: 'familyaccess',
                      name: 'Family Access',
                      path: '/account',
                  },
              ];
              defaultSecondaryMenuItem = 'profile';
          }
          else{
              defaultSecondaryMenuItem = 'auditLog';
          }
          //We want auditLog no matter what, and we want it at the end of the array
          secondaryMenuItems.push(
              {
                  key: 'auditLog',
                  name: 'Activity Log',
                  path: '/account',
              }
          );
      }

      this.setState({
          secondaryMenuItems : secondaryMenuItems,
          activeSecondaryMenuItem : defaultSecondaryMenuItem
      });
  }

  goBack = () => {
    this.setState({
      expanded: !this.state.expanded,
    });
    if (this.props.header.backButton) {
      this.props.hideHeaderBackButton();
    }
  };

  handleActiveMenuItem = (childItem) => {
    this.setState({
      activeSecondaryMenuItem: childItem,
    });

    if (this.state.windowWidth <= 768) {
      this.setState({
        expanded: !this.state.expanded,
      });
    }
  };

  renderSecondaryNavAreas = () => {
    const area = this.state.activeSecondaryMenuItem;
    switch (area) {
      case 'familyaccess':
        return <FamilyAccessContainer />;
      case 'auditLog':
        return <AuditLog />;
      case 'profile' :
        return <Profile />;
      default:
        return null;
    }
  };

  handleResize = () => {
    const windowWidth = this.state.windowWidth;
    const mobileContentPanelOpen = this.state.expanded;
    const isDesktop = (windowWidth >= 768 && mobileContentPanelOpen);

    if (!this.isUnmounted) {
      let updatedState = { windowWidth: window.innerWidth };
      if (isDesktop) {
        updatedState.expanded = !mobileContentPanelOpen;
      }

      this.setState(updatedState);
    }
  };

  handleMobileContentPanelDisplay = () => {
    this.setState({
      expanded: !this.state.expanded,
    });
  };

  renderSecondaryMenu = () =>
    <SecondaryMenu id="profile_secondary_menu" className={s.secondaryMenu}>
      {this.state.secondaryMenuItems.map(menuItem => (
        <SecondaryMenuItem
          active={menuItem.key === this.state.activeSecondaryMenuItem}
          className={s.menuItem}
          id={`menu_item_${menuItem.key}`}
          key={menuItem.key}
          handleClick={() => this.handleActiveMenuItem(menuItem.key)}
        >
          <h1 className={s.menuTitle}>{menuItem.name}</h1>
        </SecondaryMenuItem>
      ))}
    </SecondaryMenu>;

  // @TODO Update ContentPanel to use SlidingPanel
  render() {
    const mobileContentPanelIsOpen = this.state.expanded;
    const mobileContentPanelStyle = (mobileContentPanelIsOpen ? s.isActive : '');

    return (
      <Layout autoXScroll>
        <ActionsPanel className={s.actionsPanel}>
          {this.renderSecondaryMenu()}
        </ActionsPanel>
        <ContentPanel className={cx(s.contentPanel, mobileContentPanelStyle)}>
          {
            <FixedSecondaryHeaderBar className={cx(s.AccountLandingPageBackButtonContainer)}>
              <BaseBackButton buttonId={this.state.activeSecondaryMenuItem} onClick={this.goBack} buttonLabel={"Account"} />
            </FixedSecondaryHeaderBar>
          }
          {this.renderSecondaryNavAreas()}
        </ContentPanel>
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  header: state.header,
  user: state.user,
});

const mapDispatchToProps = dispatch => ({
  showHeaderBackButton: () => dispatch(showBackButton()),
  hideHeaderBackButton: () => dispatch(hideBackButton()),
  setHeaderTitle: title => dispatch(setHeaderTitle(title)),
  setMetadata: metadata => dispatch(setMetadata(metadata)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LandingPage);


// WEBPACK FOOTER //
// ./src/components/Pages/Account/LandingPage/LandingPage.js